import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const Search = r => require.ensure([], () => r(require('./views/Search.vue')), 'Search');
const Login = r => require.ensure([], () => r(require('./views/Login.vue')), 'Login');
const OrderList = r => require.ensure([], () => r(require('./views/OrderList.vue')), 'OrderList');
const ProcInfo = r => require.ensure([], () => r(require('./views/ProcInfo.vue')), 'ProcInfo');
const ShopCar = r => require.ensure([], () => r(require('./views/ShopCar.vue')), 'ShopCar');
const Index = r => require.ensure([], () => r(require('./views/Index.vue')), 'Index');
const Contact = r => require.ensure([], () => r(require('./views/Contact.vue')), 'Contact');
const SmartCabinet = r => require.ensure([], () => r(require('./views/SmartCabinet.vue')), 'SmartCabinet');
const Help = r => require.ensure([], () => r(require('./views/Help.vue')), 'Help');
const Inquiry = r => require.ensure([], () => r(require('./views/Inquiry.vue')), 'Inquiry');
const InquiryOrder = r => require.ensure([], () => r(require('./views/InquiryOrder.vue')), 'InquiryOrder');
const InquiryOrderList = r => require.ensure([], () => r(require('./views/InquiryOrderList.vue')), 'InquiryOrderList');

const helps = [
    {
        path: '/help',
        name: 'help',
        component: Help
    }
];

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'index',
            component: Index
        },
        {
            path: '/search',
            name: 'search',
            component: Search
        },
        {
            path: '/ProcInfo',
            name: 'ProcInfo',
            component: ProcInfo
        },
        {
            path: '/login',
            name: 'login',
            component: Login
        },
        {
            path: '/OrderList',
            name: 'OrderList',
            component: OrderList
        },
        {
            path: '/ProcInfo',
            name: 'ProcInfo',
            component: ProcInfo
        },
        {
            path: '/ShopCar',
            name: 'ShopCar',
            component: ShopCar
        },
        {
            path: '/Contact',
            name: 'Contact',
            component: Contact
        },
        {
            path: '/SmartCabinet',
            name: 'SmartCabinet',
            component: SmartCabinet
        },
        {
            path: '/Inquiry',
            name: 'Inquiry',
            component: Inquiry
        },
        {
            path: '/InquiryOrder',
            name: 'InquiryOrder',
            component: InquiryOrder
        },
        {
            path: '/InquiryOrderList',
            name: 'InquiryOrderList',
            component: InquiryOrderList
        },
        ...helps
    ]
});
